import * as React from "react"
import { useEffect } from "react"
import {array, object, string} from "yup";
import {batch} from "@preact/signals-react";
import {useValidatorSeeker} from "@ui-seeker/app";

import { Box } from "@mui/material"

import { CommonFiltersMarketplaces } from "@components"
import { useAppDefaultFilters } from "@hooks"
import {COMMON_FILTER_KEYS, MARKETPLACES_ROUTES} from "@constants"
import {disabledCommonFiltersSubmit, isLoadingCommonFilters, isSystemBusy, seller} from "@signals"
import {elementsInLoading, isEmpty} from "./@signals"


export default function MarketplacesSellerDeepDiveFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_ID, MARKETPLACES_ROUTES.ACCESS_KEY)

	const { isValid, errors } = useValidatorSeeker({
			seller: seller.value
		}, object({
			seller: Array.isArray(seller.value)
				? array()
					.min(1, 'Seller is required')
					.max(1, 'Only one seller can be selected')
				: string().required('Seller is required')
		})
	)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])


	useEffect(() => {
		disabledCommonFiltersSubmit.value = !isValid
	}, [isValid])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) {
			isLoadingCommonFilters.value = false
		}
	}, [elementsInLoading.value])

    return <Box data-tour="seller-deep-dive-filters">
	<CommonFiltersMarketplaces
		components={{
			buyBox: false, authorizedSeller: false, withShippingPrice: false,
			seller: true, favFilters: true, favFiltersOnlyLine: true
		}}
		compProps={{
			sku: { grid: { md: 3 } },
			skuGroup: { grid: { md: 2 } },
			seller: { error: errors?.seller, grid: { md: 4} },
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SELLERS
				],
				dashboardKey: MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_ID
			}
		}}
		onSubmit={() => {
            batch(() => {
                isEmpty.value = false
                isSystemBusy.value = false
                isLoadingCommonFilters.value = true
            })
        }}
		userFilters={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}